// extracted by mini-css-extract-plugin
export default {"root":"A72KeAmh","icon":"eLEPgwPj","title":"ZQJO2BKn"};